"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CONCAT = void 0;
const tab_1 = require("../../../tab");
exports.CONCAT = {
    description: 'Concatenate 2 or more strings',
    arg_names: ['first_string', 'next_strings'],
    args_def: [
        {
            types: ['string', 'boolean', 'date', 'int', 'number'],
            required: true,
        },
        {
            types: ['string', 'boolean', 'date', 'int', 'number'],
            required: true,
            variadic: true,
        },
    ],
    args_description: ['string', '(variadic parameter) strings to concatenate'],
    return_type: tab_1.ColumnType.STRING,
};
